import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-university" }, null, -1)

import { computed, ref, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  /** Emit raw (không khoảng trắng), mặc định true */
  unmasked?: boolean;
  validateOnBlur?: boolean;
}

const maxDisplayLength = 42; // 34 chars + spaces


export default /*#__PURE__*/_defineComponent({
  __name: 'IbanInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "VD: VN12 ACCT-000009" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    unmasked: { type: Boolean, default: true },
    validateOnBlur: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "change", "blur", "pressEnter", "validate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayValue = ref("");
const onlyIbanChars = (value: string) =>
  value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 34);

const formatIban = (raw: string) => raw.replace(/(.{4})/g, "$1 ").trim();

/** IBAN checksum (mod 97) */
const isValidIban = (iban: string) => {
  if (!iban) return true;
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const expanded = rearranged.replace(/[A-Z]/g, (ch) => String(ch.charCodeAt(0) - 55));
  let remainder = 0;
  for (const digit of expanded) {
    remainder = (remainder * 10 + Number(digit)) % 97;
  }
  return remainder === 1;
};

watch(
  () => props.modelValue,
  (val) => {
    displayValue.value = formatIban(onlyIbanChars(val ?? ""));
  },
  { immediate: true }
);

const localError = computed(() => {
  if (!props.validateOnBlur) return false;
  const raw = onlyIbanChars(props.modelValue ?? "");
  return !!raw && !isValidIban(raw);
});

const computedStatus = computed(() => props.status || (localError.value ? "error" : ""));

const onInput = (val: string) => {
  const raw = onlyIbanChars(val);
  displayValue.value = formatIban(raw);
  const emitValue = props.unmasked ? raw : displayValue.value;
  emit("update:modelValue", emitValue);
  emit("change", emitValue);
};

const onBlur = (e: FocusEvent) => {
  emit("validate", isValidIban(onlyIbanChars(props.modelValue ?? "")));
  emit("blur", e);
};

const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": [
      _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
      onInput
    ],
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: maxDisplayLength,
    status: computedStatus.value,
    class: "ant-iban-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, {
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "status"]))
}
}

})